import { Almanac } from "protos/robot_syncer/plant_profile";
import { buildCreateCategoryTemplateChange } from "portal/utils/categoryCollection/category";
import { portalApi } from "portal/state/portalApi";
import { useCallback } from "react";
import { useMutationPopups } from "portal/utils/hooks/useApiPopups";
import { useTranslation } from "react-i18next";
import { v4 as uuid } from "uuid";

export type CreateCategoryTemplateArgs = {
  name: string;
  chipIds: string[];
  almanac: Almanac;
};

export const useCreateCategoryTemplate = (
  customerUuid?: string
): ((args: CreateCategoryTemplateArgs) => Promise<string | undefined>) => {
  const { t } = useTranslation();
  const [applyCategoryChanges] = useMutationPopups(
    portalApi.endpoints.applyCategoryChanges.useMutation(),
    {
      success: t("components.categoryTemplates.messages.categoryAdded"),
    }
  );

  return useCallback(
    async ({
      name,
      chipIds,
      almanac,
    }: CreateCategoryTemplateArgs): Promise<string | undefined> => {
      const newCategoryId = uuid();
      const result = await applyCategoryChanges({
        uuid: newCategoryId,
        customerUuid,
        change: buildCreateCategoryTemplateChange({
          newCategoryId,
          versionId: uuid(),
          name,
          chipIds,
          almanac,
          customerUuid,
        }),
      });
      if (result.error) {
        return;
      }
      return newCategoryId;
    },
    [applyCategoryChanges, customerUuid]
  );
};
